module.exports = __webpack_public_path__ + "img/map.3f58eb21.png";